import { useMemo } from 'react';
import { useProjectOrganizationId } from 'store/project';
import { useCompanies } from 'store/company';
import { useContracts } from 'store/contract';
import { useLevels } from 'store/level';
import { useProcessesObject } from 'store/process';
import { useSites } from 'store/site';
import { useWorktypes } from 'store/fieldValue';

export interface UseInspectionReferencesResult {
  processes: ReturnType<typeof useProcessesObject>;
  sites: ReturnType<typeof useSites>['items'];
  levels: ReturnType<typeof useLevels>['items'];
  workTypes: ReturnType<typeof useWorktypes>['items'];
  companies: ReturnType<typeof useCompanies>['items'];
  contracts: ReturnType<typeof useContracts>['items'];
  organizationId: string;
}

export function useInspectionReferences(): UseInspectionReferencesResult {
  const organizationId = useProjectOrganizationId();

  const processes = useProcessesObject();
  const { items: sites } = useSites();
  const { items: levels } = useLevels();
  const { items: workTypes } = useWorktypes();
  const { items: companies } = useCompanies();
  const { items: contracts } = useContracts();

  return useMemo(
    () => ({
      processes,
      sites,
      levels,
      workTypes,
      companies,
      contracts,
      organizationId,
    }),
    [processes, sites, levels, workTypes, companies, contracts, organizationId]
  );
}
